var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 0H6.6C5.39 0 4.4 0.99 4.4 2.2V15.4C4.4 16.61 5.39 17.6 6.6 17.6H19.8C21.01 17.6 22 16.61 22 15.4V2.2C22 0.99 21.01 0 19.8 0ZM10.45 8.25C10.45 9.163 9.713 9.9 8.8 9.9H7.7V12.1H6.05V5.5H8.8C9.713 5.5 10.45 6.237 10.45 7.15V8.25ZM15.95 10.45C15.95 11.363 15.213 12.1 14.3 12.1H11.55V5.5H14.3C15.213 5.5 15.95 6.237 15.95 7.15V10.45ZM20.35 7.15H18.7V8.25H20.35V9.9H18.7V12.1H17.05V5.5H20.35V7.15ZM7.7 8.25H8.8V7.15H7.7V8.25ZM2.2 4.4H0V19.8C0 21.01 0.99 22 2.2 22H17.6V19.8H2.2V4.4ZM13.2 10.45H14.3V7.15H13.2V10.45Z",
    fill: "#004BA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.3699be61313c8b274e0e8b7e9757cbd3.svg";
export { ForwardRef as ReactComponent };